import { render } from "./AdminView75Liquidation.vue?vue&type=template&id=9d1bb842"
import script from "./AdminView75Liquidation.vue?vue&type=script&lang=js"
export * from "./AdminView75Liquidation.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__